import { Layout } from "antd";
import * as React from "react";
import { Outlet } from "react-router-dom";

import { Header } from "./Header";
import { LeftMenu } from "./LeftMenu";
import * as styles from "./MainFrame.module.less";

export const MainFrame: React.FC = () => (
  <Layout className={styles.mainFrame}>
    <header>
      <Header />
    </header>
    <nav>
      <LeftMenu />
    </nav>
    <main>
      <Outlet />
    </main>
  </Layout>
);
